import { Action } from '@ngrx/store';

import { ScreenData } from '../shared/screen-data.interface';
import { SigninData } from '../shared/signin-data.interface';

export const LOGIN = '[AUTH] - Login';
export const LOGIN_INIT = '[AUTH] - Initialize Store';
export const RELOGIN_URL = '[AUTH] - URL after re-login (Session Timeoue)';
export const RELOGIN_STATUS = '[AUTH] - Relogin Status';
export const LOGOUT = '[AUTH] - Logout';
export const UPDATE_SESSION_DATA = '[AUTH] - Update Session Data';
export const UPDATE_HAS_PASSTHRU_DATA = '[AUTH] - Update Has Pass Thru';
export const CHANGE_CUSTOMER = '[AUTH] - Change Customer';
export const CHANGE_FACILITY = '[AUTH] - Change Facility';
export const CHANGE_SCREEN = '[USER] - Change Screen';
export const LOCK_ROUTE = '[USER] - Lock Route';
export const UNLOCK_ROUTE = '[USER] - Unlock Route';
export const SET_API_VERSION = '[USER] - Set API Version';

export class Login implements Action {
  readonly type = LOGIN;
  constructor(public payload: SigninData) {}
}

export class LoginInit implements Action {
  readonly type = LOGIN_INIT;
}

export class ReLoginUrl implements Action {
  readonly type = RELOGIN_URL;
  constructor(public url: string) {}
}

export class ReloginStatus implements Action {
  readonly type = RELOGIN_STATUS;
  constructor(public status: string) {}
}

export class Logout implements Action {
  readonly type = LOGOUT;
}

export class ChangeCustomer implements Action {
  readonly type = CHANGE_CUSTOMER;
  constructor(public custid: string) {}
}

export class ChangeFacility implements Action {
  readonly type = CHANGE_FACILITY;
  constructor(public payload: string) {}
}

export class ChangeScreen implements Action {
  readonly type = CHANGE_SCREEN;
  constructor(public screen: ScreenData) {}
}

export class UpdateHasPassThruValue implements Action {
  readonly type = UPDATE_HAS_PASSTHRU_DATA;
  constructor(public haspassthru: string) {}
}

export class UpdateSessionData implements Action {
  readonly type = UPDATE_SESSION_DATA;
  constructor(public payload: SigninData) {}
}

export class LockRoute implements Action {
  readonly type = LOCK_ROUTE;
  constructor(public route: string) {}
}

export class UnlockRoute implements Action {
  readonly type = UNLOCK_ROUTE;
}

export class setApiVersion implements Action {
  readonly type = SET_API_VERSION;
  constructor(public version: string) {}
}

export type AuthActions =
  | Login
  | LoginInit
  | Logout
  | UpdateSessionData
  | ChangeCustomer
  | ChangeFacility
  | ChangeScreen
  | LockRoute
  | UnlockRoute
  | ReloginStatus
  | setApiVersion
  | UpdateHasPassThruValue;
